/* Sanitizace seznamů pro NotificationCenter (zvoneček).
 *
 * Zvoneček je v app-shellu (GlobalTabBar → AppLayout) na KAŽDÉ stránce. Iteruje
 * úkoly z /api/crm/tasks a čte `tk.done`/`tk.deadline`. `Array.isArray` guard na
 * setteru ochrání před NE-polem (`{}` → []), ale NE před vadnou POLOŽKOU uvnitř
 * pole: `[null, task, 42]` projde `Array.isArray`, pak `null.done` shodí celý
 * shell do error boundary = bílá stránka všude (nalezeno živou QA integrace).
 *
 * `sanitizeList` proto propustí jen pole objektů — stejný vzor jako `asArr`
 * v CRMDashboardPage. Vyexportováno, aby šlo unit-otestovat.
 */
export function sanitizeList(v) {
  return Array.isArray(v) ? v.filter((x) => x && typeof x === "object") : [];
}

export default sanitizeList;
